import { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useNavigate } from 'react-router-dom';
import './style.css';


const Navbar = () => {

    const [auth, setAuth] = useState('');

    let navigate = useNavigate();

    useEffect(() => {
        var auth = localStorage.getItem('email');
        setAuth(auth);
    },
        [])

    if (auth === null) {
        navigate('/');
    }

const LogOut = ()=>{
localStorage.removeItem('email');
localStorage.clear();
navigate('/');
}

    return(

                <nav class="navbar navbar-expand-lg navbar-light bg-light">
                    <div class="container-fluid">

                        <button type="button" id="sidebarCollapse" class="navbar-btn">
                            <span></span>
                            <span></span>
                            <span></span>
                        </button>
                        <button class="btn btn-dark d-inline-block d-lg-none ml-auto" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            <i class="fas fa-align-justify"></i>
                        </button>

                        <div class="collapse navbar-collapse" id="navbarSupportedContent">
                            <ul class="nav navbar-nav ml-auto">
                                <li class="nav-item active">
                                    <a class="nav-link" href="#">Message</a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" href="#">Profile</a>
                                </li>
                                <span className="navbar-text">
                                    <Link to="/" onClick={LogOut}>Logout</Link>
                                </span>


                            </ul>
                        </div>
                    </div>
                </nav>

    )
}

export default Navbar;